
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'FBtn'
})
class FBtn extends Vue {}

export default FBtn
